import { ReactNode } from 'react';

import { IndicatorsDisplay } from '../../../core/components/annotations/components/indicators/types.js';

/**
 * The Track slot component for XYChart Annotations
 * @public
 */
export interface XYChartAnnotationsTrackProps {
  /** track Unique ID */
  trackIdAccessor: string;
  /** Indicates what data field from the data object should be used as the label for each track */
  labelAccessor?: string;
  /** Indicates what data field from the data object should be used as the color of each track */
  colorAccessor?: string;
  /** letter/emoji/icon/glyph or Unicode character */
  symbol?: ReactNode | ((t: unknown) => ReactNode);
  /** Defines the display behaviour of marker's indicators of the entire track */
  indicatorsDisplay?: IndicatorsDisplay | ((t: unknown) => IndicatorsDisplay);
  /** Flag to hide a track */
  hidden?: boolean | ((t: unknown) => boolean);
}
export const Track = (props: XYChartAnnotationsTrackProps) => null;
Track['displayName'] = 'XYChartAnnotations.Track';
